var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPlaying)?_c('BigButton',{attrs:{"text":"Pause time-lapse","action":_vm.stop,"icon":"pause"}}):_c('BigButton',{attrs:{"text":"Play time-lapse","action":_vm.play,"icon":"play"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4763cfee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayButton.vue
// module id = null
// module chunks = 